import axios from 'axios';
import { ApiManualBalancesResponse } from '@/rennovation/planning-view/types/api/manual-balance-response';

export class ManualBalanceApiService {
	private baseUrl = '/api/manualbalance';

	async getManualWorktimeBalances(user: string, month = ''): Promise<ApiManualBalancesResponse> {
		const response = await axios.get<ApiManualBalancesResponse>(`${this.baseUrl}/workTime/${user}?month=${month}`);
		return response.data;
	}
}
